import React from "react";
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ListIcon from '@mui/icons-material/List';


const TenantMenus = [
    {
        label: 'sidebar.menu.home',
        type: "section",
        children: [
            {
                uri: "/dashboard",
                label: 'sidebar.menuItem.misc',
                type: "nav-item",
                icon: <GraphicEqIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/users",
                label: 'sidebar.menuItem.users',
                type: "nav-item",
                icon: <ListIcon sx={{fontSize: 20}}/>
            },
        ]
    },   
            
    
];

export default TenantMenus;
